import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';

export default function FAQSection({ faqs }) {
  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-center text-[#292524] mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-center text-[#78716C] mb-12">
          Everything you need to know before you begin
        </p>

        <div className="bg-white rounded-2xl border border-[#E7E5E4] overflow-hidden">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, idx) => (
              <AccordionItem 
                key={idx} 
                value={`faq-${idx}`}
                className="border-b border-[#E7E5E4] last:border-0"
              >
                <AccordionTrigger 
                  data-testid={`faq-trigger-${idx}`}
                  className="px-6 py-5 text-left hover:no-underline hover:bg-[#F4EFE6]/50 transition-colors font-heading text-lg font-bold text-[#292524] faq-trigger"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 faq-content">
                  <p className="text-[#78716C] leading-relaxed">{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
